import React, { useState, useEffect } from 'react';
import { Input, Label, Row, Col, Button, Breadcrumb, BreadcrumbItem, FormText } from 'reactstrap';

// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from '../../../components/modales/customModal';
import BasicTable from '../../../components/tables/Table';

//API Calls
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

//API Calls
const actualizarAPE = functionsHttpsCallable('ape_actualizarSolicitudEmpleo');
const exportarLista = functionsHttpsCallable('ape_exportarListaChequeo');
const crearLista = functionsHttpsCallable('ape_crearListaChequeo');
const dataListaChequeo = functionsHttpsCallable('ape_getDataListaChequeo');
const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalListaChequeo = (props) => {
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [nombre, setNombre] = useState(undefined);
    const [fechaNacimiento, setFechanacimiento] = useState(new Date(Date.now()));
    const [fechaTempInicio, setFechaTempInicio] = useState(new Date(Date.now()));
    const [fechaTempFin, setFechaTempFin] = useState(new Date(Date.now()));
    const [cedula, setCedula] = useState(undefined);
    const [direccion, setDireccion] = useState(undefined);
    const [telefono, setTelefono] = useState(undefined);
    const [titulo, setTitulo] = useState(undefined);
    const [universidad, setUniversidad] = useState(undefined);
    const [especializacion, setEspecializacion] = useState(undefined);
    const [universidadEsp, setUniversidadesp] = useState(undefined);
    const [correo, setCorreo] = useState(undefined);
    const [cargo, setCargo] = useState(undefined);
    const [calificacionTecnica, setCalificacionTecnica] = useState(props.dataAPE.calificacionPruebaTecnica ?? 0);
    const [calificacionHSEQ, setCalificacionHSEQ] = useState(props.dataAPE.calificacionHSEQ ?? 0);
    const [calificacionHabilidades, setCalificacionHabilidades] = useState(props.dataAPE.calificacionHabilidades ?? 0);
    const [calificacionEntrevista, setCalificacionEntrevista] = useState(props.dataAPE.calificacionEntrevista ?? 0);
    const [nivel, setNivel] = useState(undefined);
    const [empresa, setEmpresa] = useState(undefined);
    const [noContrato, setNocontrato] = useState(undefined);
    const [experiencia, setExperiencia] = useState([]);
    const [expReqFormacion, setExpreqformacion] = useState(undefined);
    const [ExpReqEmpirico, setExpreqempirico] = useState(undefined);
    const [matricula, setMatricula] = useState('Sí');
    const [certificadoExpe, setCertificadoexpe] = useState('Sí');
    const [licencia, setLicencia] = useState('Sí');
    const [otroDoc, setOtrodoc] = useState('Sí');
    const [obsMatricula, setObsmatricula] = useState(undefined);
    const [obsCertificadoExpe, setObscertificadoexpe] = useState(undefined);
    const [obsLicencia, setObslicencia] = useState(undefined);
    const [obsOtroDoc, setObsotrodoc] = useState(undefined);
    const [consultaLista, setConsultalista] = useState('Apto');
    const [estudioSeg, setEstudioseg] = useState('Apto');
    const [poligrafia, setPoligrafia] = useState('Apto');
    const [obsConsultaLista, setObsconsultalista] = useState(undefined);
    const [obsEstudioSeg, setObsestudioseg] = useState(undefined);
    const [obsPoligrafia, setObspoligrafia] = useState(undefined);
    const [observaciones, setObservaciones] = useState(undefined);
    const [residencia, setResidencia] = useState(undefined);
    const [tallaCamisa, setTallaCamisa] = useState(undefined);
    const [tallaPantalon, setTallaPantalon] = useState(undefined);
    const [tallaBotas, setTallaBotas] = useState(undefined);
    const [tempEmpresa, setTempEmpresa] = useState(undefined);
    const [tempAnhos, setTempAnhos] = useState(undefined);
    const [tempCargo, setTempCargo] = useState(undefined);
    const [tempObs, setTempObs] = useState(undefined);
    const [tipo, setTipo] = useState('MOC');


    useEffect(() => {
        async function ape_getDataListaChequeo() {
            props.setLoading(true)
            const req = await dataListaChequeo({
                "cod_empr": 537,
                "ape": props.id
            })
            if (req.data.data[0]) updateDataListaChequeo(req.data.data[0])
        }
        ape_getDataListaChequeo()
        props.setLoading(false)
    }, [])

    useEffect(() => {
        const epochInicio = fechaTempInicio.getTime()
        const epochFin = fechaTempFin.getTime()
        const anhos = ((Math.round((epochFin - epochInicio) / (31556926 * 1000) * 100)) / 100).toString().replace('.', ',')
        setTempAnhos(anhos)
    }, [fechaTempInicio, fechaTempFin])

    const updateDataListaChequeo = (data) => {
        setNombre(data.nombre ?? '');
        setFechanacimiento(new Date(data.fechaNacimiento._seconds * 1000) ?? '');
        setCedula(data.cedula ?? '');
        setDireccion(data.direccion ?? '');
        setTelefono(data.telefono ?? '');
        setTitulo(data.titulo ?? '');
        setUniversidad(data.universidad ?? '');
        setEspecializacion(data.especializacion ?? '');
        setUniversidadesp(data.universidadEsp ?? '');
        setCorreo(data.correo ?? '');
        setCargo(data.cargo ?? '');
        setNivel(data.nivel ?? '');
        setEmpresa(data.empresa ?? '');
        setNocontrato(data.noContrato ?? '');
        setExperiencia([...data.experiencia] ?? '');
        setExpreqformacion(data.expReqFormacion ?? '');
        setExpreqempirico(data.expReqEmpirico ?? '');
        setMatricula(data.matricula ?? 'Sí');
        setCertificadoexpe(data.certificadoExpe ?? 'Sí');
        setLicencia(data.licencia ?? 'Sí');
        setOtrodoc(data.otroDoc ?? 'Sí');
        setObsmatricula(data.obsMatricula ?? '');
        setObscertificadoexpe(data.obsCertificadoExpe ?? '');
        setObslicencia(data.obsLicencia ?? '');
        setObsotrodoc(data.obsOtroDoc ?? '');
        setConsultalista(data.consultaLista ?? 'Apto');
        setEstudioseg(data.estudioSeg ?? 'Apto');
        setPoligrafia(data.poligrafia ?? 'Apto');
        setObsconsultalista(data.obsConsultaLista ?? '');
        setObsestudioseg(data.obsEstudioSeg ?? '');
        setObspoligrafia(data.obsPoligrafia ?? '');
        setObservaciones(data.observaciones ?? '');
        setResidencia(data.residencia ?? '');
        setTallaCamisa(data.tallaCamisa ?? '');
        setTallaPantalon(data.tallaPantalon ?? '');
        setTallaBotas(data.tallaBotas ?? '');
        setTipo(data.tipo ?? '');
    }

    const getFinalValidation = () => {
        // return (nombre !== undefined && nombre !== '' &&
        //     fechaNacimiento !== undefined && fechaNacimiento !== '' &&
        //     cedula !== undefined && cedula !== '' &&
        //     direccion !== undefined && direccion !== '' &&
        //     telefono !== undefined && telefono !== '' &&
        //     titulo !== undefined && titulo !== '' &&
        //     universidad !== undefined && universidad !== '' &&
        //     especializacion !== undefined && especializacion !== '' &&
        //     universidadEsp !== undefined && universidadEsp !== '' &&
        //     correo !== undefined && correo !== '' &&
        //     cargo !== undefined && cargo !== '' &&
        //     nivel !== undefined && nivel !== '' &&
        //     empresa !== undefined && empresa !== '' &&
        //     noContrato !== undefined && noContrato !== '' &&
        //     expReqFormacion !== undefined && expReqFormacion !== '' &&
        //     ExpReqEmpirico !== undefined && ExpReqEmpirico !== '' &&
        //     matricula !== undefined && matricula !== '' &&
        //     certificadoExpe !== undefined && certificadoExpe !== '' &&
        //     licencia !== undefined && licencia !== '' &&
        //     otroDoc !== undefined && otroDoc !== '' &&
        //     obsMatricula !== undefined && obsMatricula !== '' &&
        //     obsCertificadoExpe !== undefined && obsCertificadoExpe !== '' &&
        //     obsLicencia !== undefined && obsLicencia !== '' &&
        //     obsOtroDoc !== undefined && obsOtroDoc !== '' &&
        //     consultaLista !== undefined && consultaLista !== '' &&
        //     estudioSeg !== undefined && estudioSeg !== '' &&
        //     poligrafia !== undefined && poligrafia !== '' &&
        //     obsConsultaLista !== undefined && obsConsultaLista !== '' &&
        //     obsEstudioSeg !== undefined && obsEstudioSeg !== '' &&
        //     obsPoligrafia !== undefined && obsPoligrafia !== '' &&
        //     observaciones !== undefined && observaciones !== ''
        // )
        if (cedula && typeof (cedula) !== 'number') {
            return (!cedula.includes('.') && !cedula.includes(','))
        }
        return true
    }

    const handleAddExperience = () => {
        let tempArr = [...experiencia];
        tempArr.push({
            fechaInicio: fechaTempInicio.toISOString().split('T')[0],
            fechaFin: fechaTempFin.toISOString().split('T')[0],
            anhos: tempAnhos ?? '',
            cargo: tempCargo ?? '',
            empresa: tempEmpresa ?? '',
            observaciones: tempObs ?? ''
        })
        setExperiencia([...tempArr]);
        cleanExperiencia();
    }


    const cleanExperiencia = () => {
        setFechaTempInicio(new Date(Date.now()))
        setFechaTempFin(new Date(Date.now()))
        setTempAnhos('')
        setTempCargo('')
        setTempEmpresa('')
        setTempObs('')
    }

    const keysExperiencia = [
        {
            key: 'fechaInicio',
            name: 'Fecha Inicio',
            width: 3
        },
        {
            key: 'fechaFin',
            name: 'Fecha Fin',
            width: 3
        },
        {
            key: 'cargo',
            name: 'Cargo',
            width: 2
        },
        {
            key: 'empresa',
            name: 'Empresa',
            width: 2
        },
        {
            key: 'observaciones',
            name: 'Observaciones',
            width: 2
        },
    ];

    const editExperiencia = (index, campo, valor) => {
        const tempArr = experiencia;
        tempArr[index][campo] = valor;
        setExperiencia([...tempArr]);
    }
    
    const updateAPE = async () => {
        let body = {
            cod_soli: props.id,
            cod_empr: userData.codigoEmpresa,
            data: {
                cmp_stat: 'REVISION'
            },

        }
        try {
            await actualizarAPE(body)
            props.updateAPE({
                estadoAPE: 'REVISION'
            })
            props.toastSuccess('APE actualizada!')
        }
        catch (error) {
            console.log(error)
            props.toastError('Hubo un error!')
        }
    }

    const handleDownload = async () => {
        props.setLoading(true)
        const body = {
            ape: props.id,
            tipo: (tipo !== undefined && tipo !== '') ? tipo : 'MOC',
            type: 'PDF',
            data: {
                fechaNacimiento: fechaNacimiento ? fechaNacimiento.toISOString().split('T')[0] : '',
                nombre: nombre ?? ' ',
                cedula: cedula ?? ' ',
                direccion: direccion ?? ' ',
                telefono: telefono ?? ' ',
                titulo: titulo ?? ' ',
                universidad: universidad ?? ' ',
                especializacion: especializacion ?? ' ',
                universidadEsp: universidadEsp ?? ' ',
                correo: correo ?? ' ',
                cargo: cargo ?? ' ',
                nivel: nivel ?? ' ',
                empresa: empresa ?? ' ',
                noContrato: noContrato ?? ' ',
                expReqFormacion: expReqFormacion ?? ' ',
                expReqEmpirico: ExpReqEmpirico ?? ' ',
                matricula: matricula ?? ' ',
                certificadoExpe: certificadoExpe ?? ' ',
                licencia: licencia ?? ' ',
                otroDoc: otroDoc ?? ' ',
                obsMatricula: obsMatricula ?? ' ',
                obsCertificadoExpe: obsCertificadoExpe ?? ' ',
                obsLicencia: obsLicencia ?? ' ',
                obsOtroDoc: obsOtroDoc ?? ' ',
                consultaLista: consultaLista ?? ' ',
                estudioSeg: estudioSeg ?? ' ',
                poligrafia: poligrafia ?? ' ',
                obsConsultaLista: obsConsultaLista ?? ' ',
                obsEstudioSeg: obsEstudioSeg ?? ' ',
                obsPoligrafia: obsPoligrafia ?? ' ',
                observaciones: observaciones ?? ' ',
                experiencia: experiencia,
                tallaBotas,
                tallaCamisa,
                tallaPantalon,
                residencia,
                calificacionTecnica: calificacionTecnica ?? 0,
                calificacionHSEQ: calificacionHSEQ ?? 0,
                calificacionHabilidades: calificacionHabilidades ?? 0,
                calificacionEntrevista: calificacionEntrevista ?? 0,
                elaboradoPor: userData.nombre
            }
        }
        try {
            await crearLista(body);
            props.toastSuccess('Lista de Chequeo creada!')
        }
        catch (e) {
            console.log('error', e)
            props.toastError('Hubo un error')
        }
        try {
            await updateAPE();
            props.toastSuccess('APE actualizada!')
        }
        catch (e) {
            console.log('error', e)
            props.toastError('Hubo un error')
        }
        try {
            let downloadLink = await exportarLista(body);
            let downloadWindow = window.open(downloadLink.data.data, "_blank", "noopener,noreferrer");
            if (downloadWindow) downloadWindow.opener = null
            props.toggle()
            props.setLoading(false)
            props.toastSuccess('Lista de Chequeo descargada!')
        }
        catch (e) {
            console.log('error', e)
            props.toastError('Hubo un error')
        }
        props.setLoading(false)
    }

    const renderTable = () => {
        return (
            <div>
                <br />
                <BasicTable
                    headers={['Item', 'Fecha Inicio', 'Fecha de Terminación', 'Años', 'Cargo Ocupado', 'Empresa', 'Observaciones']}
                    data={experiencia}
                />
            </div>
        )
    }
    return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                buttonTitle={'Descargar'}
                onClick={() => { handleDownload() }}
                buttonLoading={!(getFinalValidation())}
                title={`Actualizar estado a `}
            >
                <Row>
                    <Col key={`col_datos`} lg='12'>
                        <Breadcrumb>
                            <BreadcrumbItem className='BreadcrumbItem-color'>Datos Personales y Educación</BreadcrumbItem>
                        </Breadcrumb>
                    </Col>
                </Row>
                <Row>
                    <Col lg='6' md='6' xs="12" className='informe-final-select'>
                        <Label for="exampleSelect">Lista de Chequeo MOC/MONC/ADMIN</Label>
                        <Input
                            id="select_tipo"
                            name="selectTipo"
                            type="select"
                            onChange={(e) => { setTipo(e.target.value) }}
                        >
                            <option>
                                MOC
                            </option>
                            <option>
                                MONC
                            </option>
                            <option>
                                ADMIN
                            </option>
                        </Input>
                    </Col>
                </Row>
                <Row>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Nombres y Apellidos</Label>
                        <Input type="text" name="text" id="inputNombre" defaultValue={nombre !== undefined ? nombre : ''} value={nombre} onChange={(e) => setNombre(e.target.value)} />
                    </Col>
                    <Col lg='4' md='10' xs="10" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                        <Label for="exampleSelect">Fecha de Nacimiento</Label>
                        <Input
                            id="fechaNacimiento"
                            name="datetime"
                            // onKeyDown={(e) => { e.preventDefault(); }}
                            value={fechaNacimiento ? fechaNacimiento.toISOString().split('T')[0] : new Date(Date.now().getTime() + 86400000).toISOString().split('T')[0]}
                            onChange={(e) => {
                                try {
                                    if (!isNaN(new Date(e.target.value.toUpperCase()))) setFechanacimiento(new Date(e.target.value.toUpperCase()))
                                }
                                catch (error) {
                                    console.log(error)
                                }
                            }}                            
                            type="date"
                        />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Cédula</Label>
                        <Input type="text" name="text" id="inputCedula" defaultValue={cedula !== undefined ? cedula : ''} value={cedula} onChange={(e) => setCedula(e.target.value)} />
                        <FormText>
                            Valores sin puntos o comas
                        </FormText>
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Direccion</Label>
                        <Input type="text" name="text" id="inputDireccion" defaultValue={direccion !== undefined ? direccion : ''} value={direccion} onChange={(e) => setDireccion(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Telefono</Label>
                        <Input type="text" name="text" id="inputTelefono" defaultValue={telefono !== undefined ? telefono : ''} value={telefono} onChange={(e) => setTelefono(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Título</Label>
                        <Input type="text" name="text" id="inputTitulo" defaultValue={titulo !== undefined ? titulo : ''} value={titulo} onChange={(e) => setTitulo(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Universidad</Label>
                        <Input type="text" name="text" id="inputUni" defaultValue={universidad !== undefined ? universidad : ''} value={universidad} onChange={(e) => setUniversidad(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Especialización</Label>
                        <Input type="text" name="text" id="inputEsp" defaultValue={especializacion !== undefined ? especializacion : ''} value={especializacion} onChange={(e) => setEspecializacion(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Universidad Especialización</Label>
                        <Input type="text" name="text" id="inputUniEsp" defaultValue={universidadEsp !== undefined ? universidadEsp : ''} value={universidadEsp} onChange={(e) => setUniversidadesp(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Correo Electrónico</Label>
                        <Input type="text" name="text" id="inputCorreo" defaultValue={correo !== undefined ? correo : ''} value={correo} onChange={(e) => setCorreo(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Cargo</Label>
                        <Input type="text" name="text" id="inputCargo" defaultValue={cargo !== undefined ? cargo : ''} value={cargo} onChange={(e) => setCargo(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Nivel del Cargo</Label>
                        <Input type="text" name="text" id="inputNivel" defaultValue={nivel !== undefined ? nivel : ''} value={nivel} onChange={(e) => setNivel(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Empresa</Label>
                        <Input type="text" name="text" id="inputEmpresa" defaultValue={empresa !== undefined ? empresa : ''} value={empresa} onChange={(e) => setEmpresa(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Número de Contrato</Label>
                        <Input type="text" name="text" id="inputContrato" defaultValue={noContrato !== undefined ? noContrato : ''} value={noContrato} onChange={(e) => setNocontrato(e.target.value)} />
                    </Col>
                </Row>
                <Row>
                    <Col key={`col_Exp`} lg='12'>
                        <br />
                        <Breadcrumb>
                            <BreadcrumbItem className='BreadcrumbItem-color'>Resumen de Experiencia Laboral Max. 14 experiencias</BreadcrumbItem>
                        </Breadcrumb>
                    </Col>
                </Row>
                {experiencia.length > 0 ?
                    experiencia.map((exp, index) => {
                        return (
                            <Row>
                                <Col lg='12' md='12' xs="12">
                                    <Label for="exampleSelect">Experiencia {index + 1}</Label>
                                </Col>
                                {keysExperiencia.map(key => {
                                    return (
                                        <Col lg={key.width} md='12' xs="12" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                                            <Label for="exampleSelect">{key.name}</Label>
                                            <Input
                                                id="fechaTempInicio"
                                                name="datetime"
                                                defaultValue={exp[key.key]}
                                                value={exp[key.key]}
                                                onChange={(e) => editExperiencia(index, key.key, e.target.value)}
                                            />
                                        </Col>
                                    )

                                })}
                            </Row>
                        )
                    }) : null}
                <Row>
                    <Col lg='6' md='12' xs="12" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                        <Label for="exampleSelect">Fecha de Temporal de Inicio</Label>
                        <Input
                            id="fechaTempInicio"
                            name="datetime"
                            value={fechaTempInicio ? fechaTempInicio.toISOString().split('T')[0] : new Date(Date.now().getTime() + 86400000).toISOString().split('T')[0]}
                            // onChange={(e) => setFechaTempInicio(new Date(e.target.value))}
                            onChange={(e) => {
                                try {
                                    if (!isNaN(new Date(e.target.value.toUpperCase()))) setFechaTempInicio(new Date(e.target.value))
                                }
                                catch (error) {
                                    console.log(error)
                                }
                            }} 
                            
                            type="date"
                        />
                    </Col>
                    <Col lg='6' md='12' xs="12" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                        <Label for="exampleSelect">Fecha de Temporal de Fin</Label>
                        <Input
                            id="fechaTempFin"
                            name="datetime"
                            value={fechaTempFin ? fechaTempFin.toISOString().split('T')[0] : new Date(Date.now().getTime() + 86400000).toISOString().split('T')[0]}
                            // onChange={(e) => setFechaTempFin(new Date(e.target.value))}
                            onChange={(e) => {
                                try {
                                    if (!isNaN(new Date(e.target.value.toUpperCase()))) setFechaTempFin(new Date(e.target.value))
                                }
                                catch (error) {
                                    console.log(error)
                                }
                            }} 
                            type="date"
                        />
                    </Col>
                    <Col lg='2' md='8' xs="12">
                        <Label for="exampleSelect">Años</Label>
                        <Input type="text" name="text" id="inputTempAnhos" value={tempAnhos} disabled />
                    </Col>
                    <Col lg='5' md='8' xs="12">
                        <Label for="exampleSelect">Cargo</Label>
                        <Input type="text" name="text" id="inputTempCargo" value={tempCargo} onChange={(e) => setTempCargo(e.target.value)} />
                    </Col>
                    <Col lg='5' md='8' xs="12">
                        <Label for="exampleSelect">Empresa</Label>
                        <Input type="text" name="text" id="inputTempEmpr" value={tempEmpresa} onChange={(e) => setTempEmpresa(e.target.value)} />
                    </Col>
                    <Col lg='10' md='8' xs="12">
                        <Label for="exampleSelect">Observaciones</Label>
                        <Input type="text" name="text" id="inputTempObs" value={tempObs} onChange={(e) => setTempObs(e.target.value)} />
                    </Col>
                    <Col lg='2' md='8' xs="12" className='informe-final-button'>
                        <Button
                            color="primary"
                            disabled={!(tempAnhos !== undefined && tempAnhos !== '' && tempCargo !== undefined && tempCargo !== '' && tempEmpresa !== undefined && tempEmpresa !== '') || experiencia.length >= 14}
                            onClick={() => { handleAddExperience() }}>
                            Anadir
                        </Button>
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Experiencia Requerida con Formación</Label>
                        <Input type="text" name="text" id="inputExpReqFor" defaultValue={expReqFormacion !== undefined ? expReqFormacion : ''} value={expReqFormacion} onChange={(e) => setExpreqformacion(e.target.value)} />
                    </Col>
                    <Col lg='6' md='12' xs="12">
                        <Label for="exampleSelect">Experiencia Requerida si es Empirico</Label>
                        <Input type="text" name="text" id="inputExpReqEmp" defaultValue={ExpReqEmpirico !== undefined ? ExpReqEmpirico : ''} value={ExpReqEmpirico} onChange={(e) => setExpreqempirico(e.target.value)} />
                    </Col>
                    <Col key={`col_Doc`} lg='12'>
                        <br />
                        <Breadcrumb>
                            <BreadcrumbItem className='BreadcrumbItem-color'>Resultados Pruebas</BreadcrumbItem>
                        </Breadcrumb>
                    </Col>
                    {tipo === 'MOC' ? <Col lg='3' md='12' xs="12">
                        <Label for="exampleSelect">Técnicas</Label>
                        <Input type="text" name="text" id="inputExpReqEmp" defaultValue={calificacionTecnica !== undefined ? calificacionTecnica : ''} value={calificacionTecnica} onChange={(e) => setCalificacionTecnica(e.target.value)} />
                    </Col> : null}
                    <Col lg='3' md='6' xs="12">
                        <Label for="exampleSelect">HSEQ</Label>
                        <Input type="text" name="text" id="inputExpReqEmp" defaultValue={calificacionHSEQ !== undefined ? calificacionHSEQ : ''} value={calificacionHSEQ} onChange={(e) => setCalificacionHSEQ(e.target.value)} />
                    </Col>
                    {tipo === 'MOC' ? <Col lg='3' md='6' xs="12">
                        <Label for="exampleSelect">Habilidades</Label>
                        <Input type="text" name="text" id="inputExpReqEmp" defaultValue={calificacionHabilidades !== undefined ? calificacionHabilidades : ''} value={calificacionHabilidades} onChange={(e) => setCalificacionHabilidades(e.target.value)} />
                    </Col> : null}
                    <Col lg='3' md='6' xs="12">
                        <Label for="exampleSelect">Entrevista</Label>
                        <Input type="text" name="text" id="inputExpReqEmp" defaultValue={calificacionEntrevista !== undefined ? calificacionEntrevista : ''} value={calificacionEntrevista} onChange={(e) => setCalificacionEntrevista(e.target.value)} />
                    </Col>
                </Row>
                {/* <Row>
                    {experiencia.length > 0 ? renderTable() : null}
                </Row> */}
                <Row>
                    <Col key={`col_Doc`} lg='12'>
                        <br />
                        <Breadcrumb>
                            <BreadcrumbItem className='BreadcrumbItem-color'>Documentos Soporte de la Hoja de Vida</BreadcrumbItem>
                        </Breadcrumb>
                    </Col>
                    <Col lg='4' md='4' xs="12" className='informe-final-select'>
                        <Label for="exampleSelect">Tarjeta o Matricula Profesional</Label>
                        <Input
                            id="select_matricula"
                            name="selectTipo"
                            type="select"
                            onChange={(e) => { setMatricula(e.target.value) }}
                        >
                            <option>
                                Sí
                            </option>
                            <option>
                                No
                            </option>
                            <option>
                                N/A
                            </option>
                        </Input>
                    </Col>
                    <Col lg='8' md='8' xs="12">
                        <Label for="exampleSelect">Observacion</Label>
                        <Input type="text" name="text" id="inputObsMatricula" defaultValue={obsMatricula !== undefined ? obsMatricula : ''} value={obsMatricula} onChange={(e) => setObsmatricula(e.target.value)} />
                    </Col>
                    <Col lg='4' md='4' xs="12" className='informe-final-select'>
                        <Label for="exampleSelect">Certificado de Experiencia Laboral Confirmados</Label>
                        <Input
                            id="select_certificado"
                            name="selectTipo"
                            type="select"
                            onChange={(e) => { setCertificadoexpe(e.target.value) }}
                        >
                            <option>
                                Sí
                            </option>
                            <option>
                                No
                            </option>
                            <option>
                                N/A
                            </option>
                        </Input>
                    </Col>
                    <Col lg='8' md='8' xs="12">
                        <Label for="exampleSelect">Observacion</Label>
                        <Input type="text" name="text" id="inputObsCert" defaultValue={obsCertificadoExpe !== undefined ? obsCertificadoExpe : ''} value={obsCertificadoExpe} onChange={(e) => setObscertificadoexpe(e.target.value)} />
                    </Col>
                    <Col lg='4' md='4' xs="12" className='informe-final-select'>
                        <Label for="exampleSelect">Licencia de Conducción - Verificada</Label>
                        <Input
                            id="select_licencia"
                            name="selectTipo"
                            type="select"
                            onChange={(e) => { setLicencia(e.target.value) }}
                        >
                            <option>
                                Sí
                            </option>
                            <option>
                                No
                            </option>
                            <option>
                                N/A
                            </option>
                        </Input>
                    </Col>
                    <Col lg='8' md='8' xs="12">
                        <Label for="exampleSelect">Observacion</Label>
                        <Input type="text" name="text" id="inputObsLicencia" defaultValue={obsLicencia !== undefined ? obsLicencia : ''} value={obsLicencia} onChange={(e) => setObslicencia(e.target.value)} />
                    </Col>
                    <Col lg='4' md='4' xs="12" className='informe-final-select'>
                        <Label for="exampleSelect">Otro Documento:</Label>
                        <Input
                            id="select_OtroDoc"
                            name="selectTipo"
                            type="select"
                            onChange={(e) => { setOtrodoc(e.target.value) }}
                        >
                            <option>
                                Sí
                            </option>
                            <option>
                                No
                            </option>
                            <option>
                                N/A
                            </option>
                        </Input>
                    </Col>
                    <Col lg='8' md='8' xs="12">
                        <Label for="exampleSelect">Observacion</Label>
                        <Input type="text" name="text" id="inputObsOtro" defaultValue={obsOtroDoc !== undefined ? obsOtroDoc : ''} value={obsOtroDoc} onChange={(e) => setObsotrodoc(e.target.value)} />
                    </Col>
                    <Col key={`col_Req`} lg='12'>
                        <br />
                        <Breadcrumb>
                            <BreadcrumbItem className='BreadcrumbItem-color'>Requisitos de Selección</BreadcrumbItem>
                        </Breadcrumb>
                    </Col>
                    <Col lg='4' md='4' xs="12" className='informe-final-select'>
                        <Label for="exampleSelect">Verificación Consulta en lista</Label>
                        <Input
                            id="select_OtroDoc"
                            name="selectTipo"
                            type="select"
                            onChange={(e) => { setConsultalista(e.target.value) }}
                        >
                            <option>
                                Apto
                            </option>
                            <option>
                                No Apto
                            </option>
                            <option>
                                N/A
                            </option>
                        </Input>
                    </Col>
                    <Col lg='8' md='8' xs="12">
                        <Label for="exampleSelect">Observacion</Label>
                        <Input type="text" name="text" id="inputObsConsulta" defaultValue={obsConsultaLista !== undefined ? obsConsultaLista : ''} value={obsConsultaLista} onChange={(e) => setObsconsultalista(e.target.value)} />
                    </Col>
                    <Col lg='4' md='4' xs="12" className='informe-final-select'>
                        <Label for="exampleSelect">Estudio de seguridad (Respuesta Azul):</Label>
                        <Input
                            id="select_OtroDoc"
                            name="selectTipo"
                            type="select"
                            onChange={(e) => { setEstudioseg(e.target.value) }}
                        >
                            <option>
                                Apto
                            </option>
                            <option>
                                No Apto
                            </option>
                            <option>
                                N/A
                            </option>
                        </Input>
                    </Col>
                    <Col lg='8' md='8' xs="12">
                        <Label for="exampleSelect">Observacion</Label>
                        <Input type="text" name="text" id="inputObsEstSeg" defaultValue={obsEstudioSeg !== undefined ? obsEstudioSeg : ''} value={obsEstudioSeg} onChange={(e) => setObsestudioseg(e.target.value)} />
                    </Col>
                    <Col lg='4' md='4' xs="12" className='informe-final-select'>
                        <Label for="exampleSelect">Poligrafía:</Label>
                        <Input
                            id="select_OtroDoc"
                            name="selectTipo"
                            type="select"
                            onChange={(e) => { setPoligrafia(e.target.value) }}
                        >
                            <option>
                                Apto
                            </option>
                            <option>
                                No Apto
                            </option>
                            <option>
                                N/A
                            </option>
                        </Input>
                    </Col>
                    <Col lg='8' md='8' xs="12">
                        <Label for="exampleSelect">Observacion</Label>
                        <Input type="text" name="text" id="inputObsPol" defaultValue={obsPoligrafia !== undefined ? obsPoligrafia : ''} value={obsPoligrafia} onChange={(e) => setObspoligrafia(e.target.value)} />
                    </Col>
                    <Col lg='12' md='12' xs="12">
                        <Label for="exampleSelect">Observaciones</Label>
                        <Input type="text" name="text" id="inputObs" defaultValue={observaciones !== undefined ? observaciones : ''} value={observaciones} onChange={(e) => setObservaciones(e.target.value)} />
                    </Col>
                    <Col lg='12' md='12' xs="12">
                        <Label for="exampleSelect">Residencia</Label>
                        <Input type="text" name="text" id="inputObs" defaultValue={residencia !== undefined ? residencia : ''} value={residencia} onChange={(e) => setResidencia(e.target.value)} />
                    </Col>
                    <Col lg='4' md='4' xs="12">
                        <Label for="exampleSelect">Talla Camisa</Label>
                        <Input type="text" name="text" id="inputObs" defaultValue={tallaCamisa !== undefined ? tallaCamisa : ''} value={tallaCamisa} onChange={(e) => setTallaCamisa(e.target.value)} />
                    </Col>
                    <Col lg='4' md='4' xs="12">
                        <Label for="exampleSelect">Talla Pantalon</Label>
                        <Input type="text" name="text" id="inputObs" defaultValue={tallaPantalon !== undefined ? tallaPantalon : ''} value={tallaPantalon} onChange={(e) => setTallaPantalon(e.target.value)} />
                    </Col>
                    <Col lg='4' md='4' xs="12">
                        <Label for="exampleSelect">Talla Botas</Label>
                        <Input type="text" name="text" id="inputObs" defaultValue={tallaBotas !== undefined ? tallaBotas : ''} value={tallaBotas} onChange={(e) => setTallaBotas(e.target.value)} />
                    </Col>
                </Row>
            </CustomModal>
        </React.Fragment>
    );
}

export default connect(mapStateToProps)(ModalListaChequeo);